export default __webpack_public_path__ + "static/media/socialbanner.74ff873a.png";